import React from 'react';
import { makeStyles } from "@material-ui/core/styles";
import { Dialog, DialogTitle, Card, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Toolbar, Typography } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    root: {
        maxHeight: 500, 
        marginTop: "auto", 
        marginBottom: "auto"
    },
    rootTable:{
        padding: 25, 
    },
    header:{
        background: '#68389F',
        color:'white'
      },
    botonera: {
        marginTop: 25,
        marginLeft: 55,
        marginBottom: 20,
        paddingBottom: 13
    },
    formControl: {
        marginTop: 5,
        minWidth: 200,
        marginLeft: 20,
        margin: theme.spacing(1),
    }, 
}));

export const ModalTurnosDelDia  = (props) => {
    const classes = useStyles();
    const { open, setOpen, title, items } = props;

    const closeModal = () => {
        setOpen(false);
    }

    return (
        <Dialog
            fullWidth={true}
            open={open}
            onClose={closeModal}
            className={classes.root}
        >
            <DialogTitle className={classes.header}>
                <Toolbar >
                    <Typography variant="h6" >
                        {title}
                    </Typography>
                </Toolbar>
            </DialogTitle>
            <div className={classes.rootTable}>
                <Card >
                    <TableContainer component={Paper}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell align="left">Hora</TableCell>
                                    <TableCell align="left">Sobre Turno</TableCell>
                                    <TableCell align="left">Afiliado</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {items.length > 0
                                    ?
                                    items.map((item) => (
                                        <TableRow key={item.idAgenda}>
                                            <TableCell align="left">
                                                {item.hora}
                                            </TableCell>
                                            <TableCell align="left">
                                                {item.sobreTurno ? 'Si' : 'No'}
                                            </TableCell>
                                            <TableCell align="left">
                                                {!item.afiliado && !item.afiliadoExterno ? 'Libre' : (item.afiliado?.apellido_y_nombre || item.afiliadoExterno?.apellidoNombre)}
                                            </TableCell>
                                        </TableRow>
                                    ))
                                    :
                                    <TableRow style={{ height: 50 }}>
                                        <TableCell colSpan={8} style={{ textAlign: '-webkit-center' }}> Sin Registros</TableCell>
                                    </TableRow>
                                }
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Card>
            </div>
        </Dialog>
    );

};
